export enum JourneyKind {
	INVESTMENT = 'INVESTMENT',
	STANDALONE_KYC = 'STANDALONE_KYC',
	DOCUMENT = 'DOCUMENT',
}

export enum JourneyIndicatorKey {
	KYC = 'KYC',
	CONTRACTS = 'CONTRACTS',
	PAYMENTS = 'PAYMENTS',
	PROOFS = 'PROOFS',
	DECLARATIONS = 'DECLARATIONS',
	FORMS = 'FORMS',
	INVESTOR_SIGNATURES = 'INVESTOR_SIGNATURES',
	COUNTERPARTY_SIGNATURES = 'COUNTERPARTY_SIGNATURES',
}

export enum JourneyIndicatorStatus {
	COMPLETED = 'COMPLETED',
	IN_PROGRESS = 'IN_PROGRESS',
	PENDING = 'PENDING',
}
